<template>
  <MgdSidebarProvider v-model:open="sidebarCookie">
    <BugReportProvider>
      <Sidebar />
      <BugReportDialog />
      <MgdSidebarInset class="h-svh">
        <AppHeader />
        <main class="flex w-full grow flex-col gap-4 p-2 md:ps-6 md:pt-6">
          <TestEnvMessage />
          <GlobalWarningMessage class="print:hidden" />
          <AdminActAsAccountAlert class="print:hidden" />
          <slot />
        </main>
      </MgdSidebarInset>
    </BugReportProvider>
  </MgdSidebarProvider>
</template>

<script setup lang="ts">
const sidebarCookie = useCookie<boolean>("sidebar-state", {
  default: () => true,
  encode: (value) => `${value}`,
  decode: (value) => value === "true",
});
</script>
